import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M5.625 16.042h8.75c.92 0 1.667-.746 1.667-1.667v-6.25L10 3.958 3.96 8.125v6.25c0 .92.746 1.667 1.666 1.667Zm4.419-6.667v3.839m-1.919-1.92h3.839" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);